import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import AccountCreateUI from './AccountCreateUI.js'

class AccountCreateSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: [],
      // accountName
      accountName: '',
      accountNameError: null,
      // countryCode
      countryCode: this.props.context.account.countryCode,
      countryCodeError: null,
      countryList: null,
      // price
      priceId: null,
      priceIdError: null,
      priceList: null,
      // form events
      submitted: false,
    }
  }

  render() {
    return (
      <AccountCreateUI
        context={this.props.context}
        messageList={this.props.messageList}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        // accountName
        accountName={this.state.accountName}
        accountNameError={this.state.accountNameError}
        onAccountNameChange={(event) => {this.setState({accountName: event.target.value})}}
        setAccountNameError={(error) => {this.setState({accountNameError: error})}}
        // countryCode
        countryCode={this.state.countryCode}
        countryCodeError={this.state.countryCodeError}
        onCountryCodeChange={this.onCountryCodeChange}
        setCountryCodeError={(error) => {this.setState({countryCodeError: error})}}
        countryList={this.state.countryList}
        // price
        priceId={this.state.priceId}
        priceIdError={this.state.priceIdError}
        onPriceIdChange={(event) => {this.setState({priceId: event.currentTarget.getAttribute('data-price-id')})}}
        setPriceIdError={(error) => {this.setState({priceIdError: error})}}
        priceList={this.state.priceList}
        // card
        stripeApiKey={this.props.stripeApiKey}
        // form events
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        setErrorList={this.setErrorList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getCountries(context)
    this.getPrices(context, context.account.countryCode)
  }

  onCountryCodeChange = (event) => {
    this.setState({countryCode: event.target.value})
    this.getPrices(this.props.context, event.target.value)
  }

  onSubmit = (stripeToken) => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      '/api/user/accounts',
      this.onSubmitCallback, {
        accountName: this.state.accountName,
        countryCode: this.state.countryCode,
        priceId: this.state.priceId,
        stripeToken: stripeToken.token.id,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch(error.fieldName) {
        case 'accountName':
          this.setState({accountNameError: error.message})
          break;
        case 'countryCode':
          this.setState({countryCodeError: error.message})
          break;
        case 'priceId':
          this.setState({priceIdError: error.message})
          break;
        default:
      }
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    window.scrollTo({top: 0, left: 0, behavior: 'smooth'})

    if (this.state.errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.Accounts(this.props.context.session.userId))
      setTimeout(() => {
        this.props.history.push('/settings/user/teams')
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
    if (errorList && errorList.length > 0)
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }

  getCountries(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/countries`,
      cacheKey: CacheKeys.Countries(),
      callback: this.getCountriesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(this.props.context)
  }

  getCountriesCallback = (response) => {
    let countryList = response.countryList.map(country => ({key: country.code, value: country.name}))
    this.setState({countryList: countryList})
  }

  getPrices(context, countryCode) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/prices/countryCodes/${countryCode}`,
      cacheKey: CacheKeys.Prices('ca_acc_crt', countryCode, context.locale),
      callback: this.getPricesCallback,
      ttlInSecs: 3600
    })
    // accountId is not sent when creating new account and subscription
    // accountId is sent when upgrading subscription in existing account
    cacheManager.getObject2(context, {}, {})
  }

  getPricesCallback = (response) => {
    this.setState({priceList: response.priceList, priceId: response.priceList[0].priceId})
  }

}

export default withRouter(AccountCreateSF)
